export default "__VITE_ASSET__DNkApfjX__"